import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./auth/AuthContext";
import PrivateRoute from "./auth/PrivateRoute";
import MyProfile from "./pages/MyProfile";
import ErrorPage from "./pages/ErrorPage";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import Dashboard from "./pages/Dashboard";
import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";
import PaymentList from "./pages/PaymentList";
import InstanceList from "./pages/InstanceList";
import ScanInstance from "./pages/ScanInstance";
import SinglePage from "./pages/message/SinglePage";
import MediaPage from "./pages/message/MediaPage";
import ContactPage from "./pages/message/ContactPage";
import LocationPage from "./pages/message/LocationPage";
import SmsPage from "./pages/message/SmsPage";
import GroupPage from "./pages/message/GroupPage";
import TemplateList from "./pages/TemplateList";
import MessageLogList from "./pages/MessageLogList";
import PhonebookList from "./pages/PhonebookList";
import CampaignList from "./pages/CampaignList";
import APIAccess from "./pages/APIAccess";
import WebhookSetting from "./pages/WebhookSetting";
import Setting from "./pages/Setting";
import Chat from "./pages/Chat";
import DeviceList from "./pages/DeviceList";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <RouteScrollToTop />
        <Routes>
          <Route exact path="/" element={<SignInPage />} />
          <Route exact path="/login" element={<SignInPage />} />
          <Route exact path="/register" element={<SignUpPage />} />
          <Route exact path="/dashboard" element={<PrivateRoute element={Dashboard} />} />

          {/* SL */}
          <Route exact path="/payments" element={<PrivateRoute element={PaymentList} />} />
          <Route exact path="/instances" element={<PrivateRoute element={InstanceList} />} />
          <Route exact path="/devices" element={<PrivateRoute element={DeviceList} />} />
          <Route exact path="/scan-instance" element={<PrivateRoute element={ScanInstance} />} />
          {/* messages routes */}
          <Route exact path="/chat-single" element={<PrivateRoute element={SinglePage} />} />
          <Route exact path="/chat-image" element={<PrivateRoute element={MediaPage} />} />
          <Route exact path="/chat-audio" element={<PrivateRoute element={MediaPage} />} />
          <Route exact path="/chat-video" element={<PrivateRoute element={MediaPage} />} />
          <Route exact path="/chat-contact" element={<PrivateRoute element={ContactPage} />} />
          <Route exact path="/chat-location" element={<PrivateRoute element={LocationPage} />} />
          <Route exact path="/chat-sms" element={<PrivateRoute element={SmsPage} />} />
          <Route exact path="/chat-poll" element={<PrivateRoute element={MyProfile} />} />
          <Route exact path="/chat-reply" element={<PrivateRoute element={MyProfile} />} />
          <Route exact path="/chat-group" element={<PrivateRoute element={GroupPage} />} />
          
          {/* other routes */}
          <Route exact path="/templates" element={<PrivateRoute element={TemplateList} />} />
          <Route exact path="/logs" element={<PrivateRoute element={MessageLogList} />} />
          <Route exact path="/phonebooks" element={<PrivateRoute element={PhonebookList} />} />
          <Route exact path="/campaigns" element={<PrivateRoute element={CampaignList} />} />
          <Route exact path="/api-access" element={<PrivateRoute element={APIAccess} />} />
          <Route exact path="/webhook-settings" element={<PrivateRoute element={WebhookSetting} />} />
          <Route exact path="/chat-messages" element={<PrivateRoute element={Chat} />} />
          <Route exact path="/my-profile" element={<PrivateRoute element={MyProfile} />} />
          <Route exact path="/settings" element={<PrivateRoute element={Setting} />} />
          <Route exact path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;



